import React from 'react';
import { TemplateBuilderProvider } from '../../_shared/TemplateBuilder/context';
import TemplateBuilder from '../../_shared/TemplateBuilder/index';

const AgencyTemplateBuilder: React.FC = () => {
  return (
    <TemplateBuilderProvider>
      <TemplateBuilder />
    </TemplateBuilderProvider>
  );
};

export default AgencyTemplateBuilder;
